import {Component, Input, OnInit} from '@angular/core';
import {IGetImageServiceToken} from '../../../../../@core/services/images/IGetImageService';
import {GetUserAvatarService} from './get-user-avatar.service';

@Component({
    selector: 'app-user-avatar',
    templateUrl: './user-avatar.component.html',
    styleUrl: './user-avatar.component.scss',
    providers: [
        {
            provide: IGetImageServiceToken, useExisting: GetUserAvatarService,
        }]
})
export class UserAvatarComponent implements OnInit {
    private id:number | string;

    @Input({required: true})  set userId (id:string | number ) {
        this.id = id;
        this.showAvatar = true
        this.loaded = false;
    }
    get userId(){
        return this.id;
    }
    @Input({required: true}) shortcutName: string;
    @Input() cssVariant: string ="";
    @Input() cssAvatarContent: string ="";
    @Input() backgroundColor: string;
    @Input() color: string;
    @Input() height: string;
    @Input() width: string;
    @Input() alt: string;

    showAvatar = true;
    loaded = false;

    ngOnInit(): void {
       this.showAvatar = true;
       this.loaded = false;
    }

    onSuccess() {
        this.showAvatar = true;
        this.loaded = true;
    }

    onError() {
        this.showAvatar = false;
        this.loaded = false;
    }

    onLoading() {
        this.showAvatar = true;
        this.loaded = true;
    }
}
